export const HH = "HH";
export const HF = "HF";
export const IS = "IS";
export const IC = "IC";
export const P = "P";
export const L = "L";
export const TT = "TT";
export const V = "V";
export const D = "D";
export const MI = "MI";
export const FT = "FT";

export const SettingType = {
  HH: "Vacation",
  HF: "Other vacation",
  IS: "Sick",
  IC: "Child sick",
  P: "Own types",
  L: "Other leave",
  TT: "Time",
  V: "Overtime/ Time off",
  D: "Daybank",
  MI: "Mileage",
  FT: "Work hours",
};

export const MethodType = {
  daysHalf: "daysHalf",
  daysHalfDisabled: "daysHalfDisabled",
  days: "days",
  hours: "hours",
  hoursSpanned: "hoursSpanned",
  dateHoursInput: "dateHoursInput",
  checkInOut: "checkInOut",
  hoursAndDaysWhole: "hoursAndDaysWhole",
  daysHalfAndHours: "daysHalfAndHours",
  mileage: "mileage",
  daysHalfAndHoursDisabled: "daysHalfAndHoursDisabled",
};

export const StatusColor = {
  error: "#f03",
  warning: "#f8ab00",
  info: "#0fbc71",
};
